<lum-ui-autocomplete
  [placeholder]="'Search Warehouse Groups'"
  [options]="warehouseGroups"
  [debounceTime]="500"
  [loading$]="loading$"
  [displayProperty]="'label'"
  [value]="displayValue"
  (inputChangeEvent)="onChangeEvent($event)"
  (optionSelectedEvent)="onSelectEvent($event)"
  [disabled]="disabled"
  [inputClass]="inputClass"
></lum-ui-autocomplete>
